import {
    createMuiTheme,
    MuiThemeProvider,
    withStyles
} from "@material-ui/core/styles";
import $ from "jquery";
import React from "react";

export const UrlDominio = ((window.location.host.indexOf("trascenti") != -1 || window.location.host.indexOf("azurewebsites") != -1) ? 'https://' : 'http://' ) + window.location.host;

export const CmsCliente = {
    sNombre: 'CMS NORMA 035',
    sAnoVersion: '2019 versión 1.0.0',
    sAutor: 'TRASCENTI SA DE CV',
    sAviso: 'Todos los derechos reservados',
    IDVersion: sessionStorage.getItem('IDVersion') ? sessionStorage.getItem('IDVersion') : '',
    Version: sessionStorage.getItem('Version') ? sessionStorage.getItem('Version') : '',
    MaxEmpleados: (sessionStorage.getItem('MaxEmpleados') ? sessionStorage.getItem('MaxEmpleados') : 0) * 1,
    PlanContratado: sessionStorage.getItem('PlanContratado') ? sessionStorage.getItem('PlanContratado') : ''
};

export const CmsMaster = {
    //sUrl :'https://democmsn035.azurewebsites.net/'
    sUrl:  'https://norma035.eastus.cloudapp.azure.com/norma035backend/'
    //sUrl: (UrlDominio.indexOf("trascenti") != -1 || UrlDominio.indexOf("azurewebsites") != -1) ? 'https://norma035.eastus.cloudapp.azure.com/norma035backend/' : 'http://localhost:49538/'
};

//Colores nivel de riesgo
export const ColRiesgo = {
    "Nulo o despreciable": {
        classBg: 'bg-primary-light',
        classBorder: 'border-primary-light',
        hexadecimal: '#8bb8f1'
    },
    "Bajo": {
        classBg: 'bg-green-light',
        classBorder: 'border-green-light',
        hexadecimal: '#58ceb1'
    },
    "Medio": {
        classBg: 'bg-yellow',
        classBorder: 'border-yellow',
        hexadecimal: '#fad732'
    },
    "Alto": {
        classBg: 'bg-warning',
        classBorder: 'border-warning',
        hexadecimal: '#ff902b'
    },
    "Muy alto": {
        classBg: 'bg-danger-dark',
        classBorder: 'border-danger-dark',
        hexadecimal: '#ec2121'
    },
    "": {
        classBg: '',
        classBorder: '',
        hexadecimal: ''
    }
};
//Colores si o no
export const ColSiNo = {
    "no": {
        classBg: 'bg-green-light',
        classBorder: 'border-green-light',
        hexadecimal: '#58ceb1'
    },
    "si": {
        classBg: 'bg-danger-dark',
        classBorder: 'border-danger-dark',
        hexadecimal: '#ec2121'
    },
    "": {
        classBg: '',
        classBorder: '',
        hexadecimal: ''
    }
};
export const TextEllipsis = ({contenido, width}) => {
    let w = typeof width !== "undefined" ? width : "100%";
    return (
        <div className="text-pt-ellipsis" style={{ display: "block", width: w }}>
            {contenido}
        </div>
        )
}
export const posSubMenu = () => {
    $(window).scroll(function() {
        if($(window).scrollTop() > 0){
            $("#submenuUp").css({
                "top": $(window).innerWidth() > 750 ? "80px" : ($(window).scrollTop() <= 80 ? "80px" : (($(window).scrollTop() + 22) + "px")),
                "position": "fixed"
            });
        }else{
            $("#submenuUp").removeAttr("style");
            if($(window).innerWidth() <= 750 ){
                $("#submenuUp").css({
                    "top": "80px",
                    "position": "fixed"
                });
            }
        }
    });
}
export const ThemeMUIDataTable = ({DataTable}) => {
    return (
        <MuiThemeProvider theme={getMuiTheme()}>
        {DataTable}
        </MuiThemeProvider>
    )
}
export const getMuiTheme = () =>
    createMuiTheme({
        overrides: {
            MUIDataTable: {
                responsiveScroll: {
                    overflowY: 'hidden',
                    overflowX: 'auto',
                    width: 'auto',
                    maxWidth: 'auto',
                },
                //root: { wordWrap: "break-word" },
                paper: {
                    boxShadow: "none"
                }
                //,body: { wordWrap: "break-word"}
            },

            /*MUIDataTableHeadCell: {
                root: {
                  '&:nth-child(2)': {
                    width: 10
                  }
                }
              },*/
            MUIDataTableHeadCell: {
                root: {
                    fontWeight: "700",
                    fontSize: "16px",
                    backgroundColor: "#CCDBD9",
                    color: "#000000",
                    borderBottom: "4px solid #CCDBD9",
                    width: "auto",

                    //textAlign: "center"
                    //wordWrap: "break-word",
                    //whiteSpace: "nowrap"
                },
                toolButton: {
                    height: "unset",
                    justifyContent :'center'
                }
                //,body: {wordWrap: "break-word",whiteSpace: "nowrap"}
            },
            MUIDataTableBodyCell: {
                root: {
                    padding: "1px",
                    margin: "1px",
                }
                //,body: {wordWrap: "break-word"}
            }
        }
    });
// TABLES CONFIGURATION
export const TableDefaultOptionstextLabels =
    {
        body: {
            noMatch: "Ningún resultado encontrado",
            toolTip: "Ordenar",
            columnHeaderTooltip: column => `Ordenar por ${column.label}`
        },
        pagination: {
            next: "Siguiente página",
            previous: "Página anterior",
            rowsPerPage: "Filas por página:",
            displayRows: "de",
        },
        toolbar: {
            search: "Buscar",
            downloadCsv: "Exportar CSV",
            print: "Imprimir",
            viewColumns: "Ver columnas",
            filterTable: "Filtrar tabla",
        },
        filter: {
            all: "TODOS",
            title: "FILTROS",
            reset: "REINICIAR",
        },
        viewColumns: {
            title: "Ver columnas",
            titleAria: "Ver/esconder columnas",
        },
        selectedRows: {
            text: "columna(s) seleccionadas",
            delete: "Borrar",
            deleteAria: "Borrar fila",
        },
    };
